<template>
    <div class="z-max-500 z-center-margin">
        <div v-if="hashOk === null">
            {{$translate('Loading...')}}
            <v-progress-circular class="ml-2" indeterminate color="primary" />
        </div>
        <v-form v-else-if="hashOk" @submit.prevent="resetPassword">
            <v-row no-gutters>
                <v-col cols=6 md=12>
                    <v-text-field :label="$translate('New password')" v-model="password" class="ml-2 ml-md-0" type="password" />
                </v-col>
            </v-row>

            <div class="d-flex mb-2">
                <zoezi-button :text="$translate('Change password and log in')" @click="resetPassword" :disabled="!passwordLoginOk" type="submit" :loading="loading" />
            </div>
        </v-form>
        <div v-else>
            <v-alert color="error">
                <p>{{$translate('RESETPASSWORDLINK_NOT_ACTIVE')}}</p>
            </v-alert>
        </div>
    </div>
</template>

<script>

export default {
    name: 'zoezi-reset-password',

    zoezi: {
        title: 'Reset password',
        icon: 'mdi-account-key-outline'
    },

    data: () => ({
        hashOk: null,
        passwordLimit: location.hostname == 'zoezidev.se' || window.__devenv ? 3 : 6,
        password: '',
        loading: false
    }),

    computed: {
        passwordLoginOk() {
            return this.password && this.password.length >= this.passwordLimit;
        }
    },

    methods: {
        resetPassword() {
            this.loading = true;
            let hash = this.$route.query.hash;
            this.$api.post('/api/memberapi/resetPassword', null, {hash, newPassword: this.password}).then(response => {
                response.json().then(x => {
                    let data = {login: x.mail, password: this.password};
                    this.$api.post('/api/v8.0/memberapi/login', data).then(response => {
                        response.json().then(data => {
                            if (response.ok) {
                                this.$store.commit('setLoggedIn', {isLoggedIn: true, user: data});
                                this.$root.followLink('/');
                            }
                        })
                    })
                })
            })
        }
    },

    mounted() {
        this.$store.commit('setCheckoutHidden', true)
        if (!this.$route.query.hash) {
            this.hashOk = false;
        } else {
            this.$api.post('/api/memberapi/resetPassword/hash/active', null, {hash: this.$route.query.hash}).then(response => {
                response.json().then(x => {
                    this.hashOk = x.active;
                })
            })
        }
    },
    destroyed() {
        this.$store.commit('setCheckoutHidden', false)
    }
}

</script>
